import { LOGIN_RES, USER_RES, REGISTER_RES, LOGIN_MESSAGE, REGISTER_FAIL, IS_LOGIN, RESET_USER, CONFIRM_SIGNUP_RES, COUNTRIES, PRODUCTS,ACTIVE_PRODUCTS, QUOTES, QUOTE, FETCH_PRODUCT_OPTIONS, FETCH_PRODUCT_OPTIONS_ERRORED, END_USERS } from "../helpers/constants";

export default function user(state = {
    user: {},
    publicUser: {},
    loginMessage: '',
    confirmSignUpMessage: '',
    isLoggedIn: false,
    registerMessage: '',
    isRegistered: '',
    cards: [],
    notConfirm: true,
    countries: '',
    quotes: [],
    quote:{},
    options:{},
    products:[],
    activeProducts:[],
    endUsers: []
}, action) {
    switch (action.type) {
        case LOGIN_RES:
            {
                return { ...state, user: action.payload };
            }
        case USER_RES:
            {
                console.log(action.payload)
                return { ...state, publicUser: action.payload };
            }
        case REGISTER_RES:
            {
                return { ...state, registerMessage: action.payload, isRegistered: true };
            }
        case IS_LOGIN:
            {
                if (action.payload) {
                    return { ...state, isLoggedIn: action.payload };
                } else {
                    return { state: {}, isLoggedIn: action.payload };

                }
            }
        case FETCH_PRODUCT_OPTIONS:
            {
                console.log('dispatch in reducer',action.payload);
                return {
                    ...state,
                    options: action.payload
                };
            }
        case FETCH_PRODUCT_OPTIONS_ERRORED:
            {
                // console.log('dispatch in reducer',action.payload);
                return {
                    ...state,
                    options: action.payload
                };
            }
        case REGISTER_FAIL:
            {
                return { ...state, registerMessage: action.payload, isRegistered: false };
            }
        case LOGIN_MESSAGE:
            {
                return { ...state, loginMessage: action.payload };
            }
        case RESET_USER:
            {
                return {
                    user: {},
                    loginMessage: '',
                    isLoggedIn: '',
                    registerMessage: '',
                    isRegistered: '',
                };
            }
        case CONFIRM_SIGNUP_RES:
            {
                console.log(action.payload)
                return { ...state, confirmSignUpMessage: action.payload, notConfirm: action.notConfirm };
            }
        case COUNTRIES:
            {
                console.log(action.payload)
                return { ...state, countries: action.payload };
            }
        case PRODUCTS:
            {
                // console.log(action.payload)
                return { ...state, products: action.payload };
            }
        case ACTIVE_PRODUCTS:
            {
                return { ...state, activeProducts: action.payload };
            }
        case QUOTES:
            {
                // console.log('QUOTES',action.payload)
                return { ...state, quotes: action.payload || [] };
            }
        case QUOTE:
            {
                console.log(action.payload)
                return { ...state, quote: action.payload || [] };
            }
        case END_USERS:
            {
                return {...state, endUsers: action.payload || []}
            }    
        default:
            {
                if (action.type.indexOf('@@') === -1) {
                    // console.log('case not handled in reducer: ', action.type);
                }
            }
    }
    return state;
}